import {
  InMemoryCache,
  NormalizedCacheObject,
  FieldMergeFunction,
  Reference,
} from '@apollo/client'

export const createGraphQLCache = (initialState: NormalizedCacheObject = {}) =>
  new InMemoryCache({
    typePolicies: {
      Me: {
        keyFields: [],
      },
      Customer: {
        fields: {
          // Mutations return the complete address lists, including deletions.
          myAddresses: { merge: false },
          otherAddresses: { merge: false },
        },
      },
      LineItem: {
        fields: {
          // Standard and discounted prices are mutually exclusive values.
          price: { merge: false },
        },
      },
      Basket: {
        fields: {
          lineItems: {
            merge: ((existing = [], incoming, { readField }) => {
              const existingLineItems = new Map<
                string,
                { item: Reference; index: number }
              >()

              existing.forEach((item: Reference, index: number) => {
                const id = readField('id', item)
                if (typeof id === 'string') {
                  existingLineItems.set(id, { item, index })
                }
              })

              if (!Array.isArray(incoming)) {
                return incoming
              }

              return incoming.map(incomingItem => {
                const id = readField('id', incomingItem)
                if (typeof id === 'string' && existingLineItems.has(id)) {
                  const existingData = existingLineItems.get(id)
                  // istanbul ignore next
                  return existingData ? existingData.item : incomingItem
                }
                return incomingItem
              })
            }) satisfies FieldMergeFunction<Reference[], Reference[]>,
          },
        },
      },
    },
  }).restore(initialState)
